import { createStyles, FormLabel, Grid, makeStyles } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { acquirerForm } from "../../../formSchemas/signup.form";
import EColourPanel from "../../../interfaces/EColourPanel";
import DynamicForms from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import FormWizardButtons from "../../../yoello-lib/modules/dynamicForms/FormWizardButtons";
import { AcquirerCards } from "../acquirer/AcquirerCards";
import { useSignup } from "../state/SelfSignup";
import { setAcquirerData, setStage } from "../state/signup.action";
import { ESignupStages, IAcquirer } from "../types";


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            marginTop: "1rem",
        },
        label: {
            margin: '1rem'
        },
        buttonRow: {
            margin: '1.5rem 0 1rem 0'
        }
    })
)

const acquirers = [
    {
        id: "yes",
        title: "signup.acquirer.yesCardText"
    },
    {
        id: "no",
        title: "signup.acquirer.noCardText"
    }
]


export function AcquirerForm() {
    const { goBack, dispatch, acquirerData, callLeadsAPI } = useSignup();
    const classes = useStyles();
    const [merchantType, setMerchantType] = useState<string | null>(null);
    const [midStage, setMidStage] = useState(0);

    useEffect(() => {
        if (acquirerData) {
            if (typeof acquirerData.mid === "string") {
                setMerchantType('yes');
            }
        }
    }, [acquirerData])

    function _goBack() {
        if (merchantType === null
            || midStage === 0) {
            goBack();
            return;
        }
        setMidStage(0);
    }

    function onContinue() {
        if (midStage === 0 && merchantType) {
            if (merchantType === 'yes') {
                setMidStage(1);
            } else {
                dispatch(setStage(ESignupStages.COMPLETED));
            }
            return;
        }
    }
    function onSelectMerchantType(id: string) {
        if (id === merchantType) {
            setMerchantType(null);
            return;
        }
        setMerchantType(id);
    }

    async function onSubmit(data: unknown | IAcquirer) {
        dispatch(setAcquirerData(data as IAcquirer));
        await callLeadsAPI(data);
        dispatch(setStage(ESignupStages.COMPLETED));

    }

    function renderForms() {
        switch (midStage) {
            case 0:
                return <SelectAcquirer merchantType={merchantType}
                    goBack={_goBack} onContinue={onContinue}
                    onSelectMerchantType={onSelectMerchantType} />;
            case 1:
                return <AcquirerFormDetails goBack={_goBack}
                    onSubmit={onSubmit}
                    acquirerData={acquirerData} />
        }
    }

    return <div className={classes.root}>
        {renderForms()}


    </div>

}

interface ISelectAcquirerProps {
    merchantType: string | null;
    onSelectMerchantType: (id: string) => void;
    onContinue: () => void;
    goBack: () => void;
}

function SelectAcquirer({
    merchantType,
    onSelectMerchantType,
    onContinue,
    goBack
}: ISelectAcquirerProps) {
    const { t } = useTranslation();
    const classes = useStyles();
    return <>
        <div className={classes.label}>
            <FormLabel>{t('signup.acquirer.formLabel')}</FormLabel>
        </div>
        {acquirers.map((aq) => {
            return <AcquirerCards key={aq.id} id={aq.id} onClick={onSelectMerchantType}
                title={t(aq.title)} active={merchantType === aq.id} />
        })}
        <div className={classes.buttonRow}>
            <Grid container spacing={3}>
                <FormWizardButtons
                    leftButton={{
                        label: t('misc.back'),
                        type: "button",
                        onClick: goBack,
                        color: EColourPanel.DEFAULT
                    }}
                    rightButton={{
                        type: 'button',
                        onClick: onContinue,
                        disabled: merchantType === null,
                        label: t('misc.continue'),
                        endIcon: <ChevronRight />,
                        color: EColourPanel.PRIMARY
                    }}
                />
            </Grid>
        </div>
    </>
}

interface IAcquirerFormDetailsProps {
    goBack: () => void;
    onSubmit: (data: unknown | IAcquirer) => void;
    acquirerData?: IAcquirer
}

function AcquirerFormDetails({
    goBack,
    onSubmit,
    acquirerData
}: IAcquirerFormDetailsProps) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    async function submit(data: unknown) {
        setIsLoading(true);
        await onSubmit(data);
        setIsLoading(false);
    }
    return <DynamicForms
        onHandleSubmit={submit}
        formData={acquirerData}
        formKeyName="Acquirer-details"
        formRows={acquirerForm(t)}
        formButtons={{
            leftButton: {
                label: t('misc.back'),
                type: "button",
                onClick: goBack,
                color: EColourPanel.DEFAULT
            },
            rightButton: {
                type: 'submit', label: "misc.continue", endIcon: <ChevronRight />,
                color: EColourPanel.PRIMARY, disabled: isLoading
            }
        }
        }
        useFormOptions={
            {
                reValidateMode: 'onBlur',
                mode: 'onBlur'
            }
        }
    />
}